import { render } from "./LeaveStatus.vue?vue&type=template&id=6bf7f80b&scoped=true"
import script from "./LeaveStatus.vue?vue&type=script&lang=js"
export * from "./LeaveStatus.vue?vue&type=script&lang=js"

import "./LeaveStatus.vue?vue&type=style&index=0&id=6bf7f80b&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6bf7f80b"]])

export default __exports__